<template >
  <base-dialog-form ref="uploadGaraDialog" :title="$t('import_match_csv')"
    :text="garaData && garaData.titolo ? garaData.titolo : ''" color="secondary" icon="mdi-trophy-outline">
    <template v-slot:actions>
      <v-row>
        <v-col cols="12" class="text-center">
          <v-btn class="mx-2" @click="importCsv()" :disabled="!csv" color="primary">
            <v-icon class="mr-2">mdi-account-plus</v-icon>{{ $t("import") }}</v-btn>
        </v-col>
      </v-row>
    </template>

    <form>
      <v-row>
        <v-col>
          <v-select v-model="encoding" :items="encodingList" label="Encoding" required color="primary"
            persistent-hint></v-select>
        </v-col>
        <v-col>
          <v-file-input dense v-model="files" @change="onFileChange" color="primary" :label="$t('import_match_csv')"
            :show-size="true" prepend-icon="mdi-file-delimited-outline" outlined accept="text/csv" /></v-col>
      </v-row>

    </form>
  </base-dialog-form>
</template>
<script>

export default {
  name: "upload-gara",
  components: {
  },
  data() {
    return {
      idGara: null,
      files: null,
      csv: null,
      encoding: "utf-8",
      encodingList: [
        { value: "utf-8", text: "UTF-8" },
        { value: "windows-1252", text: "Windows (Western Latin)" },
      ],
      garaData: {},
    };
  },
  methods: {
    onFileChange(e) {
      let _ = this;
      if (!_.files) return;
      if (_.files) {
        _.createCsv(_.files);
      }
    },
    createCsv(file) {
      let _ = this;
      _.csv = null;
      let reader = new FileReader();
      reader.onload = (e) => {
        _.csv = e.target.result;
        _.files = null;
      };
      if (file) reader.readAsText(file, _.encoding);
    },
    loadData() {
      let _ = this;
      _.isFetching = true;

      if (_.idGara !== null) {
        let url = "/auth/eventi/getGara/" + _.idGara;
        // Eventi aperti
        _.chiamataAxios("GET", url, { body: { onlyTestata: true } }).then(
          (response) => {
            _.garaData = response.data;
          }
        );
      }
    },
    importCsv() {
      let _ = this;
      //let b64csv = btoa(_.csv)
      let params = {
        csv: _.csv,
      };
      _.chiamataAxios("PUT", "/auth/eventi/csv/importGaraCsv/" + _.idGara, {
        body: params,
        dialogLoader: true,
        msg: "always",
        secTimeout: 500,
      }).then((response) => {
        if (response.msg.esito) {
          _.$emit("isUpdated", true);
          _.$refs.uploadGaraDialog.close();
          _.files = null;
          _.selected = [];
        }
      });
    },
    open(idGara) {
      this.idGara = idGara;
      this.loadData();
      this.$refs.uploadGaraDialog.open();
    },
  },
  computed: {

  },
  mounted() {
    let _ = this;
  },
  watch: {
    idGara: function (newVal, oldVal) {
      // watch it
      this.loadData();
    },
  },
};
</script>
